module.exports = __webpack_public_path__ + "static/media/video-thumbnail-tablet-en.dd6f435a.png";